<template>
  <section>
    <component :is="layout">
      <router-view />
    </component>
  </section>
</template>
<script>
import NONAV from '@/layouts/no-nav'
import DEFAULT from '@/layouts/default'
import SIDENAV from '@/layouts/side-nav'
import LOGOONLY from '@/layouts/logo-only'

const options = {
  NONAV,
  DEFAULT,
  SIDENAV,
  LOGOONLY
}
export default {
  name: 'layout-broker',
  props: {
    name: String
  },
  computed: {
    layout() {
      let component = options[this.name.toUpperCase().replace(/\W/g, '')]
      return component || NONAV
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/broker.vue